@let item = equipment();

<app-tooltip-item-preview
  #preview
  [display]="display()"
  [bonusStats]="bonusStats()"
  [bonusResistances]="bonusResistances()"
  [bonusCombatStats]="bonusCombatStats()"
>
  <app-row-equipment-sell-value [item]="equipmentItem()" />

  @if (infusionSlotCount() > 0) {
    <app-row-infused-materials
      [infusedItemIds]="equipmentItem().infusedItemIds"
      [maxSlots]="infusionSlotCount()"
    />
  }
</app-tooltip-item-preview>

@if (sellMode()) {
  <!-- Sell mode: unselected items dim and selected ones get a heavier outline, so the total traces back to its items. -->
  <button
    type="button"
    class="relative w-[64px] h-[64px] transition-opacity cursor-pointer select-none"
    [class.opacity-50]="!selected()"
    [class.outline-4]="selected()"
    [tp]="preview.template()"
    [tpPlacement]="'top'"
    (click)="toggleSelect.emit($event)"
    appSfx="ui-click"
    [sfxTrigger]="['click', 'hover']"
  >
    <app-slot-rarity-outline
      [entry]="item"
      spritesheet="equipment"
    ></app-slot-rarity-outline>
  </button>
} @else {
  <div
    class="relative w-[64px] h-[64px] cursor-default transition-opacity"
    [tp]="preview.template()"
    [tpPlacement]="'top'"
  >
    <app-slot-rarity-outline
      [entry]="item"
      spritesheet="equipment"
    ></app-slot-rarity-outline>
  </div>
}
